<template>
  <v-card
    class="last-updated-logs"
    :loading="loading"
  >
    <v-toolbar flat>
      <v-icon
          dense
          class="mr-2"
      >mdi-update</v-icon>
      Last Updates Logs
    </v-toolbar>
    <v-divider/>
    <v-card-text>
      <template v-for="(item, index) in items">
        <div
          v-if="index < showOnly || showAll"
          v-bind:key="'item_' + index"
        >
          <v-toolbar
              class="name-toolbar mb-2"
              flat
              dense
          >
            <span class="name">
              {{ item.user.firstName }} {{ item.user.lastname }}
            </span>
            <v-spacer />
            <span>{{ item.created | datetimeToClientTimezone }}</span>
          </v-toolbar>
          <div class="mb-3">
            Edited "<b>{{ item.field.fullName }}</b>"
            from "<b>{{ item.previousValue || 'no value' }}</b>"
            to "<b>{{ item.currentValue || 'no value' }}</b>". Reason: "{{ item.editReason }}"
          </div>
          <v-divider />
        </div>
      </template>
      <div
          v-if="items.length > showOnly"
          class="text-center mt-3"
      >
        <v-btn
            v-if="showAll === false"
            text
            color="primary"
            small
            @click="showAll = true"
        >
          {{ items.length - showOnly }} More
        </v-btn>
        <v-btn
            v-if="showAll === true"
            text
            color="primary"
            small
            @click="showAll = false"
        >
          Hide
        </v-btn>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'LastUpdatesLogs',
  props: {
    items: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      showOnly: 3,
      showAll: false,
    };
  },
};
</script>

<style lang="scss">
.last-updated-logs {
  .v-card__text {
    color: black !important;
  }
  .name {
    font-weight: 500;
  }
  .name-toolbar {
    .v-toolbar__content {
      padding-left: 0px;
      padding-right: 0px;
    }
  }
}

</style>
